module.exports = __webpack_public_path__ + "static/img/craigFive.cc889d5b.png";